<template>
  <v-card
    :width="width"
    :height="height"
    @click="click"
  >
    <v-img
      class="white--text align-end"
      :src="video.preview_url"
    >
      <v-card-title class="caption pa-0">
        {{ video.poi.geotags.map(e => e.name).join(', ')}}
      </v-card-title>
      <v-card-title v-text="video.poi.name" class="caption pa-0" />
    </v-img>

    <v-card-subtitle class="pa-0">
      {{ video.poi.hashtags.map(e => `#${e.name}`).join(' ') }}
    </v-card-subtitle>

    <slot />

    <slot
      name="actions"
      v-bind:activator="activator"
    />
  </v-card>
</template>

<script>
export default {
  props: ['video', 'width', 'height'],
  name: 'VideoCard',
  data: () => ({
    activator: false,
  }),
  methods: {
    click() {
      this.activator = !this.activator;
      this.$emit('click');
    },
  },
};
</script>
